<template>
  <v-row>
    <v-col lg="7" cols="12" class="pr-0">
      <s-crud
        title="Lista de Equipos Agrícolas"
        :config="configEquipment"
        @save="save($event)"
        edit
        no-full
        add
        remove
        :filter="filter"
        search-input
        ref="crud"
        height="400"
        @rowSelected="selectedEquipment($event)"
        sortable
      >
        <template scope="props">
          <v-container>
            <v-row justify="center">
              <v-col cols="12" class="s-col-form">
                <s-text
                  v-model="props.item.EquipmentCode"
                  autofocus
                  label="Código de Equipo"
                />
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" class="s-col-form">
                <s-text
                  v-model="props.item.Description"
                  label="Descripción"
                />
              </v-col>
            </v-row>
            <v-row justify="center" v-if="props.item.AeID">
              <v-col cols="12" class="s-col-form">
                <v-switch
                  v-model="props.item.SecStatus"
                  :true-value="1"
                  :false-value="0"
                  color="primary"
                  label="Activo"
                />
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-slot:SecStatus="{ row }">
          <v-chip
            style="margin: 0px"
            x-small
            :color="row.SecStatus === 1 ? 'success' : 'error'"
          >
            <b>{{ row.SecStatus === 1 ? 'Activo' : 'Inactivo' }}</b>
          </v-chip>
        </template>
      </s-crud>
    </v-col>

    <v-col lg="5">
      <s-crud
        v-if="itemSelected"
        title="Tipo de Aplicación"
        :config="configDetail"
        @save="saveDetail($event)"
        edit
        add
        :filter="filterDetail"
        remove
        :height="440"
      >
        <template scope="props">
          <v-container>
            <v-row justify="center">
              <v-col cols="12" class="s-col-form">
                <s-text
                  v-model="props.item.Description"
                  autofocus
                  label="Descripción"
                />
              </v-col>
            </v-row>
            <v-row justify="center" v-if="props.item.AedID">
              <v-col cols="12" class="s-col-form">
                <v-switch
                  v-model="props.item.SecStatus"
                  :true-value="1"
                  :false-value="0"
                  color="primary"
                  label="Activo"
                />
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-slot:SecStatus="{ row }">
          <v-chip
            style="margin: 0px"
            x-small
            :color="row.SecStatus === 1 ? 'success' : 'error'"
          >
            <b>{{ row.SecStatus === 1 ? 'Activo' : 'Inactivo' }}</b>
          </v-chip>
        </template>
      </s-crud>
    </v-col>
  </v-row>
</template>

<script>
import _sEquipmentService from "@/services/Technicalassistance/AgriculturalEquipment.js";
import _sDetailService from "@/services/Technicalassistance/AgriculturalEquipmentDetail.js";

export default {
  name: "AgriculturalEquipment",
  data() {
    return {
      itemSelected: null,
      filter: {},
      filterDetail: { AeID: 0 },
      configDetail: {
        model: {
          AedID: "ID",
          AeID: "int",
          Description: "string",
          SecStatus: "int",
        },
        headers: [
          { text: "ID", value: "AedID", sortable: true, width: 80 },
          { text: "Descripción", value: "Description", sortable: true },
          {
            text: "Estado",
            value: "SecStatus",
            sortable: true,
            align: "center",
            width: 100,
          },
        ],
        service: _sDetailService,
      },
    };
  },

  computed: {
    configEquipment() {
      return {
        model: {
          AeID: "ID",
          EquipmentCode: "string",
          Description: "string",
          SecStatus: "int",
        },
        service: _sEquipmentService,
        headers: [
          { text: "ID", value: "AeID", sortable: true, width: 80 },
          {
            text: "Código de Equipo",
            value: "EquipmentCode",
            sortable: true,
            width: 150,
          },
          {
            text: "Descripción",
            value: "Description",
            sortable: true,
            width: 300,
          },
          {
            text: "Estado",
            value: "SecStatus",
            sortable: true,
            align: "center",
            width: 100,
          },
        ],
      };
    },
  },

  methods: {
    selectedEquipment(rows) {
      if (rows && rows.length > 0) {
        this.filterDetail.AeID = rows[0].AeID;
        this.itemSelected = rows[0];
      } else {
        this.itemSelected = null;
        this.filterDetail.AeID = 0;
      }
    },
    save(item) {
      if (!item.EquipmentCode || item.EquipmentCode.trim().length === 0) {
        this.$fun.alert("Registre el código de equipo", "warning");
        return;
      }
      if (!item.Description || item.Description.trim().length === 0) {
        this.$fun.alert("Registre la descripción", "warning");
        return;
      }
      if (item.SecStatus === undefined || item.SecStatus === null) {
        item.SecStatus = 1;
      }
      item.save();
    },
    saveDetail(item) {
      item.AeID = this.itemSelected.AeID;
      if (!item.Description || item.Description.trim().length === 0) {
        this.$fun.alert("Registre la descripción del detalle", "warning");
        return;
      }
      if (item.SecStatus === undefined || item.SecStatus === null) {
        item.SecStatus = 1;
      }
      item.save();
    },
  },
};
</script>
